import { MutationObserverOptions, useMutation } from 'react-query';

import { IsetOutRoiInput, IsetOutRoiOutput, queryClient, setOutRoi } from 'clients/api';
import { useVaiControllerContract, useUmiTokenContract, useUmiVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

type Options = MutationObserverOptions<
    IsetOutRoiOutput,
  Error,
  Omit<IsetOutRoiInput, 'umiControllerContract'>
>;

const useSetOutRoi = (options?: Options) => {
  const umiControllerContract = useUmiVaultContract();

  return useMutation(
    FunctionKey.SET_OUT_ROI,
    (params: Omit<IsetOutRoiInput, 'umiControllerContract'>) =>
        setOutRoi({
          umiControllerContract,
        ...params,
      }),
    {
      ...options,
      onSuccess: (...onSuccessParams) => {
        // Invalidate queries related to fetching the user minted VAI amount
        queryClient.invalidateQueries(FunctionKey.GET_MINTED_USERINFO);
        queryClient.invalidateQueries(FunctionKey.GET_V_TOKEN_BALANCES_ALL);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );
};

export default useSetOutRoi;
